/* Keep custom drawers keyboard operable without changing their visual design. */
(function () {
  'use strict';
  var selectors = '#skSearchDrawer,#skCartDrawer,#skWishDrawer,#skMnav,#skFilterDrawer,#skSizeGuide,#sk-notify';
  var modals = Array.from(document.querySelectorAll(selectors)), active = null, returnFocus = null;
  var originals = new Map(), wasOpen = new Map();
  function open(el) { return el.id === 'skSizeGuide' || el.id === 'sk-notify' ? !el.hidden : el.classList.contains('on'); }
  function focusables(el) { return Array.from(el.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(function (x) { return !x.disabled && x.tabIndex >= 0 && !x.closest('[hidden],[inert]') && x.getClientRects().length; }); }
  function restoreBackground() { originals.forEach(function (value, el) { el.inert = value; }); originals.clear(); }
  function isolate(el) {
    for (var node = el; node && node.parentElement && node !== document.body; node = node.parentElement) {
      Array.from(node.parentElement.children).forEach(function (sibling) {
        // Scrims keep their click-to-close behavior. They contain no focusable controls.
        if (sibling !== node && !sibling.matches('script,style,[class*="scrim"]')) { originals.set(sibling, sibling.inert); sibling.inert = true; }
      });
    }
  }
  function sync() {
    restoreBackground();
    var newlyOpened = modals.filter(function (el) { return open(el) && !wasOpen.get(el); });
    var next = newlyOpened[newlyOpened.length - 1] || (active && open(active) ? active : modals.filter(open).pop());
    modals.forEach(function (el) { var isOpen = open(el); wasOpen.set(el, isOpen); el.inert = !isOpen; el.setAttribute('aria-hidden', isOpen ? 'false' : 'true'); });
    if (next !== active) {
      if (next) {
        if (!active) returnFocus = document.activeElement;
        active = next;
        var dialog = next.matches('[role="dialog"]') ? next : next.querySelector('[role="dialog"]') || next;
        dialog.setAttribute('role', 'dialog'); dialog.setAttribute('aria-modal', 'true'); dialog.tabIndex = -1;
        if (!next.contains(document.activeElement)) (focusables(next)[0] || dialog).focus({ preventScroll: true });
      } else {
        active = null;
        if (returnFocus && returnFocus.isConnected && !returnFocus.closest('[hidden],[inert]')) returnFocus.focus({ preventScroll: true });
        returnFocus = null;
      }
    }
    if (active) { isolate(active); document.body.style.overflow = 'hidden'; }
    else { document.body.style.overflow = ''; document.documentElement.style.overflow = ''; }
  }
  var observer = new MutationObserver(sync);
  modals.forEach(function (el) { observer.observe(el, { attributes: true, attributeFilter: ['class', 'hidden'] }); });
  document.addEventListener('keydown', function (event) {
    if (active && event.key === 'Tab') {
      var items = focusables(active), first = items[0], last = items[items.length - 1];
      if (!items.length) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || !active.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !active.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
    var heart = event.target.closest('.sk-wish[role="button"]');
    if (heart && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); heart.click(); }
    var nav = event.target.closest('.sk-navitem');
    if (nav && event.key === 'Escape') { event.preventDefault(); nav.classList.add('rr-nav-dismissed'); nav.querySelector('a,button').focus(); }
  });
  document.querySelectorAll('.sk-navitem').forEach(function (el) {
    el.addEventListener('mouseleave', function () { el.classList.remove('rr-nav-dismissed'); });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) el.classList.remove('rr-nav-dismissed'); });
    el.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { el.classList.remove('rr-nav-dismissed'); var link = el.querySelector('.sk-drop a'); if (link) { e.preventDefault(); link.focus(); } } });
  });
  var tabs = Array.from(document.querySelectorAll('.sk-pdp-tab'));
  function tabsSync() { tabs.forEach(function (tab) { var on = tab.classList.contains('on'), id = tab.dataset.tab, panel = document.querySelector('.sk-pdp-panel[data-panel="' + id + '"]'); tab.id = 'rr-tab-' + id; tab.setAttribute('aria-selected', String(on)); tab.setAttribute('aria-controls', 'rr-panel-' + id); tab.tabIndex = on ? 0 : -1; if (panel) { panel.id = 'rr-panel-' + id; panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id); panel.hidden = !on; } }); }
  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', tabsSync);
    tab.addEventListener('keydown', function (e) { var index = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i + tabs.length - 1) % tabs.length : null; if (index !== null) { e.preventDefault(); tabs[index].click(); tabs[index].focus(); } });
  });
  tabsSync(); sync();
})();
